import { type FeatureModule } from '@store/features/types';

/**
 * Patient Context Bar Feature Module
 *
 * Provides patient context information (medications, diagnoses, allergies, last encounter)
 * with RTK Query caching and reusable UI components.
 */
export const patientContextBar: FeatureModule = {
  id: 'patientContextBar',
  name: 'Patient Context Bar',

  dependencies: [],

  reducers: {},

  middleware: [],

  setup: _store => {
    // Feature initialization logic if needed
  },

  cleanup: _store => {
    // Feature cleanup logic if needed
  },
};

